import React from 'react';
import { IconButton } from '@xo-union/tk-component-icons';

import styles from './index.scss';

interface Props {
  iconSize?: IconSize;
  onRotate: (arg0: RotationDirection) => void;
}

export enum IconSize {
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
}

export enum RotationDirection {
  Left = 'LEFT',
  Right = 'RIGHT',
}

export const RotationControls: React.FC<Props> = ({ iconSize, onRotate }) => {
  const size = iconSize || 'md';

  return (
    <>
      <IconButton
        data-testid="rotate-left"
        name="refresh"
        size={size}
        aria-label="Rotate left"
        // @ts-ignore
        onClick={(): void => onRotate(RotationDirection.Left)}
      />
      <IconButton
        data-testid="rotate-right"
        name="refresh"
        className={styles.flip}
        size={size}
        aria-label="Rotate right"
        // @ts-ignore
        onClick={(): void => onRotate(RotationDirection.Right)}
      />
    </>
  );
};
